import { render, staticRenderFns } from "./TeamTaxes.vue?vue&type=template&id=c39ddff8&scoped=true&"
import script from "./TeamTaxes.vue?vue&type=script&lang=js&"
export * from "./TeamTaxes.vue?vue&type=script&lang=js&"
import style0 from "./TeamTaxes.vue?vue&type=style&index=0&id=c39ddff8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c39ddff8",
  null
  
)

export default component.exports